import React from 'react';

export default function CustomToggle({ content, classes }) {
  
  return (
    <div className={`customToggle w-100 d-flex`}>
      <div className="d-flex justify-content-start w-100 header-content">
        {content.icon_one && (
          <img className="icon_one align-self-center" alt="icon" src={content.icon_one} />
        )}
        {content.header && (
          <div className="pr-3 text-break align-self-center text-left">{content.header}</div>
        )}
        {content.filterCount > 0 && (
          <div className="d-flex justify-content-center align-items-center align-self-center accordion-counter">
            <div className=" ">{content.filterCount}</div>
          </div>
        )}
        <div className="align-self-center  ml-auto">
          {content.icon_two && <img className="toggle-icon" alt="arrow" src={content.icon_two} />}
        </div>
      </div>
    </div>
  );
}
